export class AcceptFileConstants {
  static readonly ACCEPTED_FILES: Record<string, string> = {
    c: 'text/x-c',
    cpp: 'text/x-c++',
    cs: 'text/x-csharp',
    css: 'text/css',
    csv: 'text/csv',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    gif: 'image/gif',
    go: 'text/x-golang',
    html: 'text/html',
    java: 'text/x-java',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    js: 'text/javascript',
    json: 'application/json',
    md: 'text/markdown',
    pdf: 'application/pdf',
    php: 'text/x-php',
    pkl: 'application/octet-stream',
    png: 'image/png',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    py: 'text/x-python',
    py2: 'text/x-script.python',
    rb: 'text/x-ruby',
    tar: 'application/x-tar',
    tex: 'text/x-tex',
    ts: 'application/typescript',
    txt: 'text/plain',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xml: 'application/xml',
    zip: 'application/zip',
  };
}
